// Archivo para el botón Get
// GetButton.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Icon from '@mui/icons-material/Visibility'

const GetButton = ({ entityType, onClick, loading, disabled, itemId }) => {
    const { t } = useTranslation()

    const buttonText = loading
        ? t('buttons.loading')
        : t(
            `buttons.view${entityType.charAt(0).toUpperCase() + entityType.slice(1)
            }`
        )

    return (
        <button
            className={`button get-button ${entityType}-get-button`}
            onClick={() => onClick(itemId)}
            disabled={disabled || loading}
            aria-label={buttonText}
        >
            <Icon fontSize="small" />
            {!loading && <span>{buttonText}</span>}
            {loading && <span className="button-spinner" />}
        </button>
    )
}

GetButton.propTypes = {
    entityType: PropTypes.oneOf(['user', 'client', 'product', 'activity', 'task'])
        .isRequired,
    onClick: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    disabled: PropTypes.bool,
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

GetButton.defaultProps = {
    loading: false,
    disabled: false,
}

export default GetButton
